import React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import ProfileSection from '/component/partial/profile/ProfileSection';
import {CoachInfoCard} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './Stats.style';
import {StatsProps} from './Stats.types';

export const Stats = ({
  tt,
  seniorCoachCount = 0,
  executiveDirectorCount = 0,
  fibcCount = 0,
  fiblCount = 0,
}: StatsProps) => (
  <ProfileSection
    analyticsTitle="Team Makeup"
    style={{base: styles.base}}
    title={tt('heading', 'Team Makeup')}>
    <View style={styles.listItem}>
      <ListItem
        label={
          <Text allowFontScaling maxFontSizeMultiplier={2}>
            {tt('count.seniorCoach', 'Senior Coach Teams')}
          </Text>
        }
        suffix={
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            testID={CoachInfoCard.sc}
            variant="button">
            {seniorCoachCount}
          </Text>
        }
      />
    </View>
    <View style={[styles.listItem, styles.listItemWithBorder]}>
      <ListItem
        label={
          <Text allowFontScaling maxFontSizeMultiplier={2}>
            {tt('count.executiveDirector', 'Executive Director Teams')}
          </Text>
        }
        suffix={
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            testID={CoachInfoCard.ed}
            variant="button">
            {executiveDirectorCount}
          </Text>
        }
      />
    </View>
    <View style={[styles.listItem, styles.listItemWithBorder]}>
      <ListItem
        label={
          <Text allowFontScaling maxFontSizeMultiplier={2}>
            {tt('count.fibc', 'FIBC Teams')}
          </Text>
        }
        suffix={
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            testID={CoachInfoCard.fibc}
            variant="button">
            {fibcCount}
          </Text>
        }
      />
    </View>
    <View style={[styles.listItem, styles.listItemWithBorder]}>
      <ListItem
        label={
          <Text allowFontScaling maxFontSizeMultiplier={2}>
            {tt('count.fibl', 'FIBL Teams')}
          </Text>
        }
        suffix={
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            testID={CoachInfoCard.fibl}
            variant="button">
            {fiblCount}
          </Text>
        }
      />
    </View>
  </ProfileSection>
);

export default withTranslation('screen.coachTeams.section.stats')(Stats);
